<div class="project-header">
  <div class="navigation">
    <button mat-icon-button class="back-btn" (click)="goBack()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="project-info">
      <div class="project-name-container">
        <!-- EHQ-409: project names are never editable. -->
        <h1 class="project-name">
          {{ projectName() }}
        </h1>
      </div>

      <div class="selectors">
        <app-version-dropdown
          [projectVersions]="projectVersions()"
          [selectedVersionId]="selectedVersionId()"
          [currentVersion]="currentVersion()"
          [emptyStateMessage]="getVersionEmptyStateMessage()"
          [disabled]="false"
          (versionSelected)="onVersionSelected($event)"
          (newVersionRequested)="onNewVersionRequested()"
        ></app-version-dropdown>

        @if (onApis()) {
          <app-dappa-api-dropdown [selectedApiId]="selectedApiId()"></app-dappa-api-dropdown>
        } @else {
          <app-workflow-dropdown
            [projectId]="projectId().toString()"
            [selectedWorkflowId]="selectedWorkflowId()"
            [currentWorkflow]="currentWorkflow()"
            [disabled]="false"
            (workflowSelected)="onWorkflowSelected($event)"
            (newWorkflowRequested)="onNewWorkflowRequested()"
            (workflowDeleted)="onWorkflowDeleted($event)"
          ></app-workflow-dropdown>
        }
      </div>
    </div>
  </div>

  <div class="right-section">
    <!-- Search Input positioned on the right -->
    <div class="search-container">
      <app-search-autocomplete
        placeholder="Search project"
        searchType="all"
        (resultSelected)="onResultSelected($event)"
        #searchComponent
        class="search-component"
      >
      </app-search-autocomplete>
    </div>

    <!-- Controls -->
    <div class="controls">
      <app-project-lock
        [projectId]="projectId()"
        [projectVersions]="allProjectVersions()"
        [selectedVersionId]="selectedVersionId()"
      ></app-project-lock>

      <app-project-watch [projectId]="projectId()"></app-project-watch>

      <button
        mat-button
        class="view-toggle"
        [matMenuTriggerFor]="viewMenu"
        [matTooltip]="
          'Current: ' +
          (isViewModeActive(viewModeEnum.FULL) ? 'Full View' : 'Compact View')
        "
      >
        <mat-icon>{{
          isViewModeActive(viewModeEnum.FULL) ? "view_module" : "view_comfy"
        }}</mat-icon>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #viewMenu="matMenu">
        <button
          mat-menu-item
          (click)="setViewMode(viewModeEnum.FULL)"
          [class.active]="isViewModeActive(viewModeEnum.FULL)"
        >
          <div class="menu-item-content">
            <span>Full View</span>
            @if (isViewModeActive(viewModeEnum.FULL)) {
              <mat-icon>check</mat-icon>
            }
          </div>
        </button>
        <button
          mat-menu-item
          (click)="setViewMode(viewModeEnum.COMPACT)"
          [class.active]="isViewModeActive(viewModeEnum.COMPACT)"
        >
          <div class="menu-item-content">
            <span>Compact View</span>
            @if (isViewModeActive(viewModeEnum.COMPACT)) {
              <mat-icon>check</mat-icon>
            }
          </div>
        </button>
      </mat-menu>
    </div>

    <!-- User profile / avatar -->
    <div class="header-profile">
      <app-profile compact></app-profile>
    </div>
  </div>
</div>
